// noinspection JSUnusedGlobalSymbols
// File auto-generated on: 2025-06-03T15:14:56.942Z

export type PostMediaFileApiResponse =
  /** status 200 OK */ MediaPostMediaFileResponse;
export type PostMediaFileApiArg = {
    "X-Recaptcha-Token": string;
    mediaPostMediaFileRequest: MediaPostMediaFileRequest;
};
export type PostMediaMediastreamvalidatorApiResponse =
  /** status 200 OK */ MediaPostMediaStreamValidatorResponse;
export type PostMediaMediastreamvalidatorApiArg = {
    "X-Recaptcha-Token": string;
    mediaPostMediaStreamValidatorRequest: MediaPostMediaStreamValidatorRequest;
};
export type FfprobeReport = {
    [key: string]: any;
};
export type MediaFfProbeReport = {
    duration?: null | number;
    error?: null | string;
    response?: FfprobeReport;
    success?: boolean;
    usage?: null | number;
};
export type MediainfoReport = {
    [key: string]: any;
};
export type MediaMediainfoReport = {
    duration?: null | number;
    error?: null | string;
    response?: MediainfoReport;
    success?: boolean;
    usage?: null | number;
};
export type ProbefileResponseMetadata = {
    io_usage?: null | number;
    queue_time?: null | number;
    request_id?: null | string;
};
export type ReportAudio = {
    bitrate?: {
    /** Audio average bit-rate */
        average?: number;
    };
    channels?: {
    /** Audio channels number */
        count?: null | number;
        /** Audio channels layout */
        layout?: null | string;
    };
    codec?: {
    /** Audio codec description */
        description?: null | string;
        /** Audio codec FourCC code */
        four_cc?: null | string;
        /** Audio codec ID */
        id?: number;
        /** Audio codec name */
        name?: null | string;
    };
    /** Parameters diff */
    diff?: {
        [key: string]: any;
    };
    /** Audio duration */
    duration?: null | number;
    /** Audio frames count */
    frames_count?: null | number;
    /** Audio sample rate */
    sample_rate?: null | number;
    /** Audio start time */
    start_time?: null | number;
};
export type ReportContainer = {
    /** Audio streams count */
    audio_count?: null | number;
    bitrate?: {
    /** Average bit-rate */
        average?: number;
        /** Maximum bit-rate */
        maximum?: null | number;
    };
    /** Container description */
    description?: null | string;
    /** Parameters diff */
    diff?: {
        [key: string]: any;
    };
    /** Media duration */
    duration?: null | number;
    /** File size */
    file_size?: null | number;
    /** Container format */
    format?: null | string;
    /** Video streams count */
    video_count?: null | number;
};
export type ReportVideo = {
    bitrate?: {
    /** Video average bit-rate */
        average?: number;
        /** Video maximum bit-rate */
        maximum?: null | number;
        /** Video minimum bit-rate */
        minimum?: null | number;
        /** Video nominal bit-rate */
        nominal?: null | number;
    };
    codec?: {
        description?: null | string;
        /** Video codec FourCC code */
        four_cc?: null | string;
        /** Video codec ID */
        id?: number;
        /** Video codec Name */
        name?: null | string;
        /** Sub coded type */
        sub_type?: null | string;
        /** Sub codec description */
        sub_type_description?: null | string;
    };
    color?: {
    /** Video color matrix */
        matrix?: null | string;
        /** Video color primaries */
        primaries?: null | string;
        /** Video color range */
        range?: null | string;
        /** Video color transfer */
        transfer?: null | string;
    };
    /** Parameters diff */
    diff?: {
        [key: string]: any;
    };
    /** Video duration */
    duration?: null | number;
    frame_rate?: {
    /** Video frame rate denominator */
        denominator?: number;
        /** Video frame rate numerator */
        numerator?: number;
    };
    /** Video frames count */
    frames_count?: null | number;
    pixel_format?: {
    /** Video bit depth */
        bit_depth?: null | number;
        /** Video chroma subsampling */
        chroma_subsampling?: null | string;
        /** Video color model */
        color_model?: null | string;
        /** Video components order */
        components_order?: null | string;
        /** Video stream has alpha-chanel */
        has_alpha?: null | boolean;
    };
    size?: {
    /** Video display aspect ratio */
        display_aspect_ratio?: null | number;
        /** Video frame height */
        height?: null | number;
        /** Video sample aspect ratio */
        sample_aspect_ratio?: null | number;
        /** Video frame width */
        width?: null | number;
    };
    /** Video start time */
    start_time?: null | number;
};
export type ProbereportReport = {
    /** Audio Streams List */
    audio?: ReportAudio[];
    /** Media Container */
    container?: ReportContainer;
    /** Video Streams List */
    video?: ReportVideo[];
};
export type MediaProbeReport = {
    duration?: null | number;
    error?: null | string;
    response?: ProbereportReport;
    success?: boolean;
    usage?: null | number;
};
export type MediaPostMediaFileResponse = {
    error?: null | string;
    ffprobe?: MediaFfProbeReport;
    mediainfo?: MediaMediainfoReport;
    metadata?: ProbefileResponseMetadata;
    probe_report?: MediaProbeReport;
    success?: boolean;
};
export type ProbefileRequestFfProbe = {
    analyzeduration?: number;
    byte_binary_prefix?: boolean;
    count_frames?: boolean;
    count_packets?: boolean;
    enabled?: boolean;
    max_probe_packets?: number;
    max_ts_probe?: number;
    output_format?: Output_format;
    prefix?: boolean;
    probesize?: number;
    read_intervals?: null | string;
    select_streams?: null | string;
    sexagesimal?: boolean;
    show_chapters?: boolean;
    show_data?: boolean;
    show_data_hash?: boolean;
    show_entries?: null | string;
    show_error?: boolean;
    show_format?: boolean;
    show_frames?: boolean;
    show_log?: Show_log;
    show_packets?: boolean;
    show_private_data?: boolean;
    show_programs?: boolean;
    show_streams?: boolean;
    skip_estimate_duration_from_pts?: boolean;
    skip_frame?: Skip_frame;
    timeout?: number;
    tls_verify?: boolean;
    unit?: boolean;
    version?: VersionsFFProbeRequestVersion;
};
export type ProbefileRequestMediaInfo = {
    enabled?: boolean;
    full?: boolean;
    language?: string;
    output?: Output;
    parse_speed?: number;
    read_by_human?: boolean;
    ssl_ignore_security?: boolean;
    timeout?: number;
    version?: VersionsMediaInfoRequestVersion;
};
export type ProbefileRequestReport = {
    diff?: boolean;
    enabled?: boolean;
    prefer?: Prefer;
};
export type MediaPostMediaFileRequest = {
    ffprobe?: ProbefileRequestFfProbe;
    inject_json?: boolean;
    mediainfo?: ProbefileRequestMediaInfo;
    only?: Only;
    output?: Output2;
    probe_report?: ProbefileRequestReport;
    queue_timeout?: number;
    timeout?: number;
    url?: string;
};
export type ProbemsvResponseMetadata = {
    duration?: null | number;
    io_usage?: null | number;
    queue_time?: null | number;
    request_id?: null | string;
    usage?: null | number;
};
export type MediaPostMediaStreamValidatorResponse = {
    cli_output?: null | string;
    error?: null | string;
    metadata?: ProbemsvResponseMetadata;
    output?: any;
    success?: boolean;
};
export type MediaPostMediaStreamValidatorRequest = {
    enable_cli_output?: boolean;
    inject_json?: boolean;
    parse_playlist_only?: boolean;
    queue_timeout?: number;
    timeout?: number;
    url: string;
};
export enum Output_format {
    Default = "default",
    Csv = "csv",
    Flat = "flat",
    Ini = "ini",
    Json = "json",
    Xml = "xml",
}
export enum Show_log {
    Quiet = "quiet",
    Panic = "panic",
    Fatal = "fatal",
    Error = "error",
    Warning = "warning",
    Info = "info",
    Verbose = "verbose",
    Debug = "debug",
    Trace = "trace",
}
export enum Skip_frame {
    None = "none",
    Default = "default",
    Noref = "noref",
    Bidir = "bidir",
    Nokey = "nokey",
    Nointra = "nointra",
    All = "all",
}
export enum VersionsFFProbeRequestVersion {
    Latest = "latest",
    $70 = "7.0",
    $60 = "6.0",
    $51 = "5.1",
    $50 = "5.0",
    $44 = "4.4",
    $43 = "4.3",
    $42 = "4.2",
    $41 = "4.1",
    $40 = "4.0",
    $34 = "3.4",
    $33 = "3.3",
}
export enum Output {
    Text = "Text",
    Html = "HTML",
    Xml = "XML",
    Json = "JSON",
    EbuCore18Ps = "EBUCore_1.8_ps",
    EbuCore18Sp = "EBUCore_1.8_sp",
    EbuCore18PsJson = "EBUCore_1.8_ps_JSON",
    EbuCore18SpJson = "EBUCore_1.8_sp_JSON",
    EbuCore16 = "EBUCore_1.6",
    Fims13 = "FIMS_1.3",
    Mpeg7Strict = "MPEG-7_Strict",
    Mpeg7Relaxed = "MPEG-7_Relaxed",
    Mpeg7Extended = "MPEG-7_Extended",
    PbCore21 = "PBCore_2.1",
    PbCore20 = "PBCore_2.0",
    PbCore12 = "PBCore_1.2",
    NisoZ3987 = "NISO_Z39.87",
}
export enum VersionsMediaInfoRequestVersion {
    Latest = "latest",
    $2406 = "24.06",
    $2311 = "23.11",
    $2212 = "22.12",
    $2109 = "21.09",
    $2009 = "20.09",
    $1909 = "19.09",
    $1812 = "18.12",
}
export enum Only {
    Ffprobe = "ffprobe",
    Mediainfo = "mediainfo",
    ProbeReport = "probe_report",
}
export enum Output2 {
    Json = "json",
}
export enum Prefer {
    Ffprobe = "ffprobe",
    Mediainfo = "mediainfo",
}
